export const INITIAL_NUM_TRIPS = 21;
export const INITIAL_TRIPS_OFFSET = 8;
export const TRIPS_PER_REQUEST = 4;

export const INITIAL_TRIPS_TO_SHOW = 16;
export const MAX_VIDEOS = 3;

export const MAX_NAME_DISPLAY_LENGTH = 16;

export const INITIAL_REVIEWS_TO_SHOW = 2;
export const REVIEWS_TO_SHOW_PER_CLICK = 2;
export const REVIEWS_TO_GET_PER_FETCH = 10;

export const NOTIFICATION_DURATION = 5000;

export const MIN_REVIEWS_TO_SHOW_RATING = 10;

// export const SITE_TITLE = 'Ford Ranger Getaways';
export const SITE_TITLE = 'Ford Ranger Getaways | SDAC Ford Malaysia';

import {
  getPricePerPax,
  combineStr
} from '../js/utility';

import imgAll from '../images/v_filter_all_1.jpg';
import imgRaptor from '../images/v_filter_raptor_1.jpg';
import imgWildtrak from '../images/v_filter_wildtrak_1.jpg';
import imgXLT from '../images/v_filter_xlt_1.jpg';

import tShirtBeach from '../images/img_tshirt_1.png';
import tShirtCity from '../images/img_tshirt_2.png';
import tShirtPower from '../images/img_tshirt_3.png';
import tShirtBackyard from '../images/img_tshirt_4.png';
import tShirtGif from '../images/ford_tshirt.gif';

export const vehicleFilters = [
  {
    name: 'All vehicles',
    img_url: imgAll,
  },
  {
    name: 'Ford Ranger Raptor',
    img_url: imgRaptor,
  },
  {
    name: 'Ford Ranger WildTrak',
    img_url: imgWildtrak,
  },
  {
    name: 'Ford Ranger XLT Plus',
    img_url: imgXLT,
  },
];

export const sortFilters = [
  {
    name: 'lowToHigh',
    sortFunc: function(a, b) {
      return getPricePerPax(a.trip_price).adult - getPricePerPax(b.trip_price).adult;
    },
  },
  {
    name: 'highToLow',
    sortFunc: function(a, b) {
      return getPricePerPax(b.trip_price).adult - getPricePerPax(a.trip_price).adult;
    },
  },
  // {
  //   name: 'featured',
  //   sortFunc: null,
  // },

  // {
  //   name: 'highestRated',
  //   sortFunc: function(a, b) {
  //     return parseFloat(b.rating) - parseFloat(a.rating);
  //   },
  // },
  {
    name: 'state',
    sortFunc: function(a, b) {
      return combineStr(a).localeCompare(combineStr(b));
    },
  },
  {
    name: 'default',
    sortFunc: function(a, b) {
      return a.order - b.order;
    },
  },
  // {
  //     name: 'mostRecent',
  //     sortFunc: null,
  // },
];

export const tShirtSizes = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL'
];

export const bookingStatuses = {
  'Booking Pending': 'yellow',
  'Processing Booking': 'yellow',
  'Booking Confirmed': 'green',
  'Booking Completed': 'green',
  'Booking Cancelled': 'red',
  'Booking Rejected': 'red',
};

export const languages = {
  en: {
    code: 'en',
    str: 'en',
  },
  ms: {
    code: 'ms',
    str: 'bm',
  },
  'zh-CN': {
    code: 'zh-CN',
    str: '中文',
  },
};

export const tShirtTheme = {
  culture: tShirtGif,//tShirtCity,
  beach: tShirtGif,//tShirtBeach,
  jungle: tShirtGif,//tShirtBackyard,
  food: tShirtGif,//tShirtBackyard,
  city: tShirtGif,//tShirtCity,
  racing: tShirtGif,//tShirtPower,
};

export const SDAC_EMAIL = 'sdacford@simedarby.com';

export const difficultyName = [
  // 'Unset',
  'Beginner',
  'Intermediate',
  'Advanced'
];

// AUTH EXCEPTIONS
export const USER_NOT_CONFIRMED = 'UserNotConfirmedException';
export const INVALID_PASSWORD = 'InvalidPasswordException';
export const USERNAME_EXISTS = 'UsernameExistsException';
